import * as React from 'react';
import {
  BookIcon,
  CuboidIcon,
  GlobeIcon,
  WalletIcon,
  CalendarIcon,
  CalendarDaysIcon
} from 'lucide-react';

import { routes } from '@workspace/routes';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TikTokIcon,
  XIcon
} from '@workspace/ui/components/brand-icons';

export const MENU_LINKS = [
  {
    title: 'Product',
    items: [
      {
        title: 'Website',
        description: 'Create your personalized wedding website',
        icon: <GlobeIcon className="size-5 shrink-0" />,
        href: '/website',
        external: false
      },
      {
        title: 'Budget',
        description: 'Track spending and stay on budget',
        icon: <WalletIcon className="size-5 shrink-0" />,
        href: '/budget',
        external: false
      },
      {
        title: 'Events',
        description: 'Plan and organize your wedding events',
        icon: <CalendarIcon className="size-5 shrink-0" />,
        href: '/events',
        external: false
      },
      {
        title: 'Timeline',
        description: 'Plan every milestone of your journey',
        icon: <CalendarDaysIcon className="size-5 shrink-0" />,
        href: '/timeline',
        external: false
      }
    ]
  },
  {
    title: 'Budget Explorer',
    href: '/budget-explorer',
    external: false
  },
  {
    title: 'Contact',
    href: routes.marketing.Contact,
    external: false
  },
  {
    title: 'Blog',
    href: routes.marketing.Blog,
    external: false
  },
  {
    title: 'Story',
    href: routes.marketing.Story,
    external: false
  }
];

export const FOOTER_LINKS = [
  {
    title: 'Product',
    links: [
      { name: 'Website', href: '/website', external: false },
      { name: 'Budget', href: '/budget', external: false },
      { name: 'Events', href: '/events', external: false },
      { name: 'Timeline', href: '/timeline', external: false }
    ]
  },
  {
    title: 'Resources',
    links: [
      { name: 'Budget Explorer', href: '/budget-explorer', external: false },
      { name: 'Contact', href: routes.marketing.Contact, external: false }
    ]
  },
  {
    title: 'About',
    links: [
      { name: 'Story', href: routes.marketing.Story, external: false },
      { name: 'Blog', href: routes.marketing.Blog, external: false }
    ]
  },
  {
    title: 'Legal',
    links: [
      {
        name: 'Terms of Use',
        href: routes.marketing.TermsOfUse,
        external: false
      },
      {
        name: 'Privacy Policy',
        href: routes.marketing.PrivacyPolicy,
        external: false
      },
      {
        name: 'Cookie Policy',
        href: routes.marketing.CookiePolicy,
        external: false
      }
    ]
  }
];

export const SOCIAL_LINKS = [
  {
    name: 'X (formerly Twitter)',
    href: '#',
    icon: <XIcon className="size-4 shrink-0" />
  },
  {
    name: 'LinkedIn',
    href: '#',
    icon: <LinkedInIcon className="size-4 shrink-0" />
  },
  {
    name: 'Facebook',
    href: '#',
    icon: <FacebookIcon className="size-4 shrink-0" />
  },
  {
    name: 'Instagram',
    href: '#',
    icon: <InstagramIcon className="size-4 shrink-0" />
  },
  {
    name: 'TikTok',
    href: '#',
    icon: <TikTokIcon className="size-4 shrink-0" />
  }
];

export const DOCS_LINKS = [
  {
    title: 'Getting Started',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Introduction',
        href: '/docs',
        items: []
      },
      {
        title: 'Dependencies',
        href: '/docs/dependencies',
        items: []
      }
    ]
  },
  {
    title: 'Guides',
    icon: <BookIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Using MDX',
        href: '/docs/using-mdx',
        items: []
      }
    ]
  }
];
